module.exports = __webpack_public_path__ + "static/media/298264.a0924bff.png";